import { IconVerfied } from '@prisjakt/ui/icon';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { useAppContext } from '@prisjakt/ui-app-context';
import React from 'react';
import { MediumUp, MobileOnly } from 'src/ui/block';
import { StyledBadge } from './styles';
import { usePriceRowContext } from '../../../price-row-context';
import { Tooltip } from '@prisjakt/ui/tooltip';
import { Direction } from '@prisjakt/ui';

type Props = {
  className?: string;
};

export const AuthorizedDealerBadge: React.FC<Props> = ({ className }) => {
  const { offer, brand } = usePriceRowContext();
  const { t } = useAppContext();

  const content = (
    <>
      <MobileOnly className={className}>
        <StyledBadge circular icon={IconVerfied} color="BLUE" />
      </MobileOnly>

      <MediumUp className={className}>
        <StyledBadge
          text={
            <BodySmallText weight={600} style={{ fontSize: 12 }}>
              {t('store', 'brand.recommended-retailer')}
            </BodySmallText>
          }
          icon={IconVerfied}
          color="BLUE"
        />
      </MediumUp>
    </>
  );

  if (!brand || !offer.store) {
    return content;
  }

  return (
    <Tooltip
      title={t('store', 'store.recommended-retailer-brand', {
        brand: brand.name,
        store: offer.store.name,
      })}
      placement={Direction.Left}
    >
      {content}
    </Tooltip>
  );
};
